import { Route, Routes } from "react-router-dom";
import EditDeleteColumn from "./Common/EditDeleteColumn";
import GenericAddCreator from "./Common/GenericAddForm";
import GenericListView from "./Common/GenericListView";

const getColumns = (link) => [
  {
    field: "mr_id",
    headerName: "MR ID",
    formLayoutAttr: {
      row: 1,
      outerStyles: {
        width: "10%",
        flex: "none",
      },
      valueGetterFunction: ({ id }) => `MR_${id}`,
      inputProps: {
        disabled: true,
      },
    },
    gridLayoutAttr: {},
  },
  {
    field: "username",
    headerName: "UserName",
    formLayoutAttr: {
      row: 1,
    },
  },
  {
    field: "mrName",
    headerName: "Name",
    formLayoutAttr: {
      row: 1,
    },
    gridLayoutAttr: {},
  },
  {
    field: "address",
    headerName: "Address",
    formLayoutAttr: {
      row: 2,
    },
  },
  {
    field: "mobile",
    headerName: "Mobile",
    formLayoutAttr: {
      row: 2,
      type: "tel",
      otherProps: {},
    },
    gridLayoutAttr: {},
  },
  {
    field: "headQuarter",
    headerName: "Head Quarter",
    formLayoutAttr: {
      row: 3,
      type: "list",
      table: "headquarters",
      tableKey: "name",
    },
    gridLayoutAttr: {},
  },
  {
    field: "identityNo",
    headerName: "Identity No.",
    formLayoutAttr: {
      row: 1,
    },
    gridLayoutAttr: {},
  },
  {
    field: "allowance",
    headerName: "Daily Allowance",
    formLayoutAttr: {
      row: 1,
    },
    gridLayoutAttr: {},
  },
  {
    field: "petrol",
    headerName: "Petrol Rate",
    formLayoutAttr: {
      row: 1,
    },
    gridLayoutAttr: {},
  },
  {
    field: "email",
    headerName: "Email ID",
    formLayoutAttr: {
      row: 3,
      type: "email",
    },
  },
  {
    field: "password",
    headerName: "Password",
    formLayoutAttr: {
      row: 3,
      type: "password",
    },
  },
  {
    headerName: "Edit | Delete",
    gridLayoutAttr: {
      cellRenderer: EditDeleteColumn,
      cellRendererParams: {
        link: link,
        table: "mrs"
      },
    },
  },
];

function AddMr({ link }) {
  const label = "MR";
  return (
    <Routes>
      <Route
        path="/"
        element={
          <GenericListView
            link={link}
            table={"mrs"}
            getColumns={getColumns}
            label={label}
          />
        }
      />
      <Route
        path={"/upsert/:updateId"}
        element={
          <GenericAddCreator
            getColumns={getColumns}
            label={label}
            table={"mrs"}
            updateData={{}}
            link={link}
          />
        }
      />
      <Route
        path={"/upsert"}
        element={
          <GenericAddCreator
            getColumns={getColumns}
            label={label}
            table={"mrs"}
            updateData={{}}
            link={link}
          />
        }
      />
    </Routes>
  );
}

export default AddMr;
